import { useEffect, useRef } from 'react'
import { useLeafletContext } from '@react-leaflet/core'
import config from '../../config/BaseMapConfig'
import { getDayString } from '../utils/fogHeihgtsUtils'

const CustomTileLayer = (props) => {

  const {
    date,
    lastUpdated,
    finalSliderValue,
    potentialFogTileLayer,
  } = props

  const { layerContainer, map } = useLeafletContext()
  const container = layerContainer ?? map
  const day = getDayString(date)
  const tileLayerRef = useRef(null)

  const formattedDate = new Date(lastUpdated).toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });

  let tileLayer;

  useEffect(() => {

    if (tileLayerRef.current && container.hasLayer(tileLayerRef.current)) {
      container.removeLayer(tileLayerRef.current)
    }

    let attribution;
    let url;

    if (potentialFogTileLayer) {

      attribution = `Karte © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap </a>| <a href="https://www.openstreetmap.org/note/new#map=7/46.8259/8.2">Verbessere die Karte</a> | Potenzielle Nebelobergrenze`;
      url = config.overlay_maps.potential_fog.tile_url + finalSliderValue;

    } else {

      attribution = `Karte © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap </a>| <a href="https://www.openstreetmap.org/note/new#map=7/46.8259/8.2">Verbessere die Karte</a> | Prognose vom ${formattedDate.replace(',', '')} MEZ`;
      url = config.overlay_maps.actual_fog.tile_url + day;

    }

    const layer = L.tileLayer(url, { attribution, opacity: 0.6, tms: true })

    container.attributionControl.setPrefix()
    layer.setZIndex(100)
    container.addLayer(layer)
    tileLayerRef.current = layer

  }, [map, container, tileLayer, date, day, formattedDate, finalSliderValue, potentialFogTileLayer])

}

export default CustomTileLayer
